import cx from 'classnames';
import { CircleFill } from 'react-bootstrap-icons';

export function ToolbarButton({
    onClick,
    tooltip,
    visible = false,
    disabled = false,
    showDot = false,
    dotVariant = 'warning',
    children,
}) {
    return (
        <button
            type="button"
            data-uk-tooltip={tooltip}
            className={cx('btn-editor-toolbar', { visible })}
            onClick={onClick}
            disabled={disabled}
        >
            {children}

            {showDot && (
                <CircleFill
                    className={`position-absolute text-${dotVariant}`}
                    style={{
                        top: -4,
                        right: -3,
                        width: 9,
                        height: 9,
                    }}
                    size={9}
                />
            )}
        </button>
    );
}
